import React from 'react';
import { Typography, AppBar } from '@mui/material';
import Box from '@mui/material/Box';

export default function HeadBar() {
    return (
        <AppBar position="static">
            <Box
                backgroundColor={'#5B9BD5'}
                paddingY={1}
                textAlign={"center"}
                flexGrow={1}>
                <Typography variant="h6" component="div" fontWeight={'bold'}>
                    Resource Sorting Station
                </Typography>
                <Typography variant="subtitle1" component="div" paddingX={0.3} fontWeight={'bold'}>
                    Brought to you by the NUS Zero Waste Taskforce
                </Typography>
            </Box>
        </AppBar>
    )
}
//#003D7C